<div class="container">
  <mat-tab-group
    [selectedIndex]="selected.value"
    (selectedTabChange)="selectedTab($event)"
  >
    <mat-tab label="Historial">
      <div class="w-100 mt-4">
        <data-table
          title="Registro"
          [columns]="columnasEntryRecord"
          [configuration]="configurationEntryRecord"
          [reloadTable]="reloadTableEntryRecord"
          [params]="params"
          [url]="EndpointDictionary.userEntryRecord.USER_ENTRY_RECORD_TABLE"
          (income)="incomeUserRegister($event)"
          (exit)="exitUserRegister($event)"
          (edit)="editarUserRegister($event)"
          [headerFilters]="headerFilters"
          [headerFileXlsm]="headerFileXlsm"
        ></data-table>
      </div>
    </mat-tab>
    <mat-tab *ngIf="selected.value == 1" label="{{ label }}">
      <div class="W-100 mt-3">
        <app-user-entry-record-detail
          [income]="isIncome"
          [exit]="isExit"
          [edit]="isEdit"
          [bodyEdit]="body"
          (completeRegister)="completeRegister($event)"
        >
        </app-user-entry-record-detail>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
